var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-trash fa-lg icon-button",attrs:{"title":"Excluir Movimentação Mínima"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarExcluir()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }